<template>
  <div
    class="simple-loader"
    v-if="loading"
    :class="{ 'visible': visible }"
  >
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'SimpleLoader',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.visible = true;
    }, 10); // petit délai pour déclencher la transition
  }
};
</script>

<style scoped>
.simple-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: 0;
  transition: opacity 3s;
}

.simple-loader.visible {
  opacity: 1;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 4px solid var(--colorLight);
  border-top: 4px solid var(--colorVeryDark);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>